module.exports = __webpack_public_path__ + "static/img/NF.34975e4c.svg";